import { createFileRoute } from "@tanstack/react-router";
import { SideNavLayout } from "@/components/layouts/side-nav-layout";
import { NotFoundErrorPage } from "@/lib/error-boundary";
import { PlatformGuard } from "@/components/platform-guard";
import { PLATFORMS } from "@/types/platform.types";
import { ActiveClientSelectDialog } from "@/components/dialogs/active-client-select-dialog/active-client-select-dialog";

export const Route = createFileRoute("/_authenticated/fleet")({
	component: Fleet,
	notFoundComponent: NotFoundErrorPage,
});

function Fleet() {
	return (
		<PlatformGuard>
			<ActiveClientSelectDialog />
			<SideNavLayout platform={PLATFORMS.FLEET} />
		</PlatformGuard>
	);
}
